const routes = [
  {
    path: '*',
    redirect: '/home',
    omitFromNav: true,
  },
];

export default routes;
